module.exports = __webpack_public_path__ + "img/img_dzf.da3663c4.svg";